export const REACT_ROUTER_4 = 'REACT_ROUTER_4';
export const REACT_ROUTER_2 = 'REACT_ROUTER_2';
